/**
* @Description: list
* @author XuZiYu
* @date 2021-07-19 15:05
*/
<template>
  <div class="wrapper">
    <ctl-header :title="title" :onBack="goBack"></ctl-header>
    <van-pull-refresh v-model="refreshLogin" @refresh="getList">
      <div class="item" v-for="(v,i) in list" :key="i" @click="onDetail(v)">

        <div class="item-title">
          <div class="left">申请时间：{{v.createdTime | formatTime('YYYY-MM-DD HH:mm:ss')}}</div>
          <div
            :class="['right',v.ensureStatus === 3 && 'success',(v.ensureStatus === 5 || v.ensureStatus === 2) && 'error' ]">
            {{v.ensureStatusStr}}
          </div>
        </div>

        <div class="item-content">所在城市：{{v.examCityCode}}

          学员姓名：{{v.stuName}}

          证件号：{{v.stuIdcard}}
        </div>

        <div class="item-footer" v-if="v.ensureStatus === 2">
          <div class="btn-update" @click.stop="onUpdate(v)">修改申请信息</div>
        </div>
      </div>

      <div class="empty" v-if="list.length === 0">
        <img class="empty-icon" src="@/assets/public/picture_empty.png" alt="">
        暂无补偿记录
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { PullRefresh, Toast } from 'vant'

export default {
    name: 'list',
    components: {
        [PullRefresh.name]: PullRefresh,
        [Toast.name]: Toast
    },
    data () {
        return {
            title: '补偿记录',
            refreshLogin: false,
            form: {
                vipUserId: '',
                compensateId: '',
                subject: ''
            },
            list: []

        }
    },
    methods: {
        goBack () {
            this.$router.replace({ name: 'ensureCard', query: { vipUserId: this.form.vipUserId } })
        },
        getList () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.compensateList(this.form).then(res => {
                Toast.clear()
                this.refreshLogin = false
                if (res.status) {
                    this.list = res.result || []
                }
            })
        },
        onDetail (v) {
            this.$router.push({ name: 'ensureApplyDetail', query: { compensateId: v.id } })
        },
        onUpdate (v) {
            this.$router.push({
                name: 'ensureApplyUpdate',
                query: { compensateId: v.id, vipUserId: this.form.vipUserId }
            })
        }
    },
    created () {
        this.title = String(this.$route.query.subject) === '1' ? '科一补偿记录' : '科四补偿记录'
        this.form.vipUserId = this.$route.query.vipUserId
        this.form.compensateId = this.$route.query.compensateId
        this.form.subject = this.$route.query.subject

        this.getList()
    }

}
</script>

<style scoped lang="scss">

  .wrapper {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fafafa;
  }

  .van-pull-refresh {
    padding-top: 15px;
    overflow: auto;
    flex: 1;
  }

  .item {
    box-sizing: border-box;
    padding: 0 15px 25px;
    margin: 0 auto 15px;
    width: 345px;
    min-height: 160px;
    background: #FFFFFF;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
    border-radius: 5px;

    .item-title {
      padding: 15px 0 10px;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;

      .left {
        flex: 1;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
      }

      .right {
        font-size: 15px;
        font-weight: 400;
        color: #333333;
      }

      .success {
        color: #53CB85;
      }

      .error {
        color: #FF5050;
      }
    }

    .item-content {
      margin-top: 20px;
      white-space: pre-line;
      font-size: 15px;
      font-weight: 400;
      color: #333333;
      line-height: 15px;
    }

    .item-footer {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;

      .btn-update {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        height: 30px;
        border-radius: 3px;
        border: 1px solid #CCCCCC;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }
    }
  }

  .empty {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 18px;
    color: #999;
    .empty-icon {
      margin-top: 100px;
      margin-bottom: 10px;
      width: 150px;
    }
  }

</style>
